export default __webpack_public_path__ + "static/media/pnsv_stand_Freightliner.ea35658f.png";